import { GridRowId } from '@material-ui/data-grid';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import en from '../../../lang/en-us';
import { SubmitButton } from '../../../lib/Button';
import { TableColumn, TableWithCollapse } from '../../../lib/DataTable';
import { useTableWithCollapse } from '../../../lib/DataTable/customHooks';
import { getPanFundDetails } from '../../../redux-store/actions/link';
import { LIST_PROTFOLIO_PAYLOAD, SCHEMES_RESPONSE } from '../../../redux-store/types/portfolio';
import { addDialCode, OTP_ACTIONS } from '../../../utils/constants';
import { maskMobileNumber } from '../../../utils/utilityFunctions';
import NoFoliosFound from '../../dashboard/makeNct/NoFoliosFound';
const { dashboard } = en;

export interface PAN_FOLIO_DATA extends SCHEMES_RESPONSE {
    balUnits?: number;
    firstHolderName?: string;
    fund?: string;
    id: GridRowId;
    pan?: string;
}

export type REQUESTBODY = {
    amc: string;
    folio: Array<number>;
};

export type PAN_DETAILED_FUNDS = {
    folios: PAN_FOLIO_DATA[];
};

const Columns: TableColumn[] = [
    {
        field: 'id',
        headerName: 'FOLIO',
    },
    {
        field: 'amcName',
        headerName: 'FUND House',
        width: 250,
    },
    {
        field: 'pan',
        headerName: 'PAN',
        valueGetter: ({ row }) => (row.pan ? row.pan : row.pekrn || 'Not Available'),
        width: 200,
    },
    {
        field: 'mobile',
        headerName: 'CONTACT NO.',
        valueGetter: ({ row }) => maskMobileNumber(row.mobile),
        width: 200,
    },
];

function PanFundList(props: any) {
    const [rowData, setRowData] = useState<PAN_FOLIO_DATA[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const {
        selectedRows: targetFunds,
        setSelectedRows: setTargetFunds,
        filteredData,
        tableRows,
        tableColumns,
    } = useTableWithCollapse<PAN_FOLIO_DATA[]>({ rows: rowData, columns: Columns, loading });

    useEffect(() => {
        async function callApi() {
            try {
                setLoading(true);
                const { userInfo, isEmail, reqId } = props.location.state || {};
                const payload: any = {
                    email: isEmail ? userInfo : '',
                    mobile: !isEmail ? addDialCode(userInfo) : '',
                    reqId: reqId,
                    action: OTP_ACTIONS.PRELOGIN_UPDATE_PAN,
                };
                const { body: panDetails = {} } = await props.getPanFundDetails(payload);
                const { folios = [] }: PAN_DETAILED_FUNDS = panDetails;
                setRowData(() => folios.map((fund) => ({ ...fund, id: fund.folio })));
                setLoading(false);
            } catch (err: any) {
                alert(err.message);
                setLoading(false);
            }
        }
        callApi();
        return () => { };
    }, []);

    const _isRowSelectable = ({ checked }: { row: PAN_DETAILED_FUNDS; checked?: boolean }) => {
        return targetFunds.length > 2 && checked ? false : true;
    };
    const _toolTipTextGet = ({ checked }: { row: PAN_DETAILED_FUNDS; checked?: boolean }) => {
        return targetFunds.length > 2 && !checked ? dashboard.UpdatePan.UpdatePanCondition : '';
    };

    const handleSubmit = () => {
        const { reqId, otpRef, userInfo, isEmail } = props.location.state;
        props.history.push('update-pan-selected', {
            userInfo,
            targetFunds,
            reqId,
            otpRef,
        });
    };
    return (
        <div className="curved-bg">
            <h2 className="heading">
                <a onClick={() => props.history.push('/')}>
                    <img src="/images/left-arrow-black.svg" alt="icon" />
                </a>
                {dashboard.UpdatePan.UpdatePanHeading}
            </h2>
            <div className="curved-bg-content curved-bg-table-outer">
                <div className="curved-bg-content-table">
                    <h5> {dashboard.UpdatePan.UpdatePanInfo}</h5>
                    {loading || rowData.length ? (
                        <div className="curved-table-content">
                            <TableWithCollapse
                                isRowSelectable={_isRowSelectable}
                                toolTipTextGetter={_toolTipTextGet}
                                setSelectedRows={setTargetFunds}
                                selectedRows={targetFunds}
                                rows={tableRows}
                                columns={tableColumns}
                                checkBoxEnabled
                                disableAllSelection
                                toolTipEnabled
                                filteredData={filteredData}
                            />
                        </div>
                    ) : (
                        <NoFoliosFound />
                    )}
                </div>
                <div className="curved-bg-content-inner-bottom">
                    <SubmitButton
                        disabled={!targetFunds.length}
                        label={dashboard.UpdatePan.buttonText}
                        className="customBtn"
                        onClick={handleSubmit}
                    />
                </div>
            </div>
        </div>
    );
}

export default connect(null, { getPanFundDetails })(PanFundList);
